<template>
  <div class="autocomplete-wrapper">

    <label class="hint">
      Город
    </label>

    <div
      class="input-wrapper"
      :class="{
        active: !!selectedCityId
      }"
    >

      <div class="location-icon">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 21C12 21 18 15.8 18 10.5C18 6.91 15.31 4 12 4C8.69 4 6 6.91 6 10.5C6 15.8 12 21 12 21Z"
            stroke="currentColor"
            stroke-width="1.7"
          />

          <circle
            cx="12"
            cy="10"
            r="2.2"
            stroke="currentColor"
            stroke-width="1.7"
          />
        </svg>
      </div>

      <select
        v-model="selectedCityId"
        class="city-select"
        @change="emitSelection"
      >
        <option
          disabled
          value=""
        >
          Выберите город
        </option>

        <option
          v-for="city in allCities"
          :key="city._id"
          :value="city._id"
        >
          {{ city.city }}
        </option>
      </select>

      <div class="select-arrow">
        <svg
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6 8L10 12L14 8"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

    </div>

    <div
      v-if="selectedCity"
      class="selected-hint"
    >
      <span class="selected-dot"></span>

      {{ selectedCity.city }}
    </div>

  </div>
</template>


<script setup>

import {
  computed,
  onMounted,
  ref
} from "vue";

import CitiesService
  from "../api/CitiesService";


const model =
  defineModel({
    type: Object,
    default: null
  });


const selectedCityId =
  ref("");

const allCities =
  ref([]);


const selectedCity =
  computed(() => {

    return allCities.value.find(
      city =>
        city._id === selectedCityId.value
    ) || null;

  });


onMounted(
  async () => {

    try {

      const cities =
        await CitiesService.fetchCities();

      allCities.value =
        cities || [];


      if (
        model.value?._id
      ) {

        selectedCityId.value =
          model.value._id;

      }

    } catch (error) {

      console.error(
        "❌ Ошибка загрузки городов:",
        error
      );

    }

  }
);


const emitSelection = () => {

  const selected =
    allCities.value.find(
      city =>
        city._id === selectedCityId.value
    );


  model.value =
    selected || null;

};

</script>


<style scoped>

* {
  box-sizing: border-box;
}


/* ============================================================
   WRAPPER
============================================================ */

.autocomplete-wrapper {
  width: 100%;
}


.hint {
  display: block;

  margin-bottom: 8px;

  color: #626a75;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;
}


/* ============================================================
   INPUT
============================================================ */

.input-wrapper {
  position: relative;

  width: 100%;
  min-height: 48px;

  display: flex;
  align-items: center;

  gap: 10px;

  padding:
    0
    13px;

  background:
    #f8f9fb;

  border:
    1px solid
    rgba(
      31,
      44,
      62,
      0.08
    );

  border-radius:
    12px;

  transition:
    background-color
    0.2s ease,
    border-color
    0.2s ease,
    box-shadow
    0.2s ease,
    transform
    0.2s ease;
}


.input-wrapper:hover {
  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.20
    );
}


.input-wrapper:focus-within {
  background:
    #ffffff;

  border-color:
    rgba(
      52,
      127,
      231,
      0.55
    );

  box-shadow:
    0 0 0 3px
    rgba(
      52,
      127,
      231,
      0.08
    );
}


.input-wrapper.active {
  border-color:
    rgba(
      52,
      127,
      231,
      0.28
    );

  background:
    rgba(
      52,
      127,
      231,
      0.035
    );
}


/* ============================================================
   ICON
============================================================ */

.location-icon {
  width: 32px;
  height: 32px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #347fe7;

  background:
    rgba(
      52,
      127,
      231,
      0.085
    );

  border-radius:
    9px;

  transition:
    transform
    0.2s ease,
    background-color
    0.2s ease;
}


.location-icon svg {
  width: 16px;
  height: 16px;
}


.input-wrapper:hover
.location-icon {
  transform:
    scale(1.04);
}


.input-wrapper.active
.location-icon {
  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #2887f7,
      #4a6fe5
    );

  box-shadow:
    0 5px 12px
    rgba(
      40,
      135,
      247,
      0.18
    );
}


/* ============================================================
   SELECT
============================================================ */

.city-select {
  width: 100%;
  height: 46px;

  padding: 0;

  color:
    #343941;

  background:
    transparent;

  border:
    none;

  outline:
    none;

  cursor:
    pointer;

  appearance:
    none;

  -webkit-appearance:
    none;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    12px;
}


.city-select:invalid {
  color:
    #a9afb8;
}


/* ============================================================
   ARROW
============================================================ */

.select-arrow {
  width: 26px;
  height: 26px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  color:
    #959ca6;

  pointer-events:
    none;

  transition:
    color
    0.2s ease,
    transform
    0.2s ease;
}


.select-arrow svg {
  width: 15px;
  height: 15px;
}


.input-wrapper:focus-within
.select-arrow {
  color:
    #347fe7;

  transform:
    translateY(1px);
}


/* ============================================================
   SELECTED
============================================================ */

.selected-hint {
  display: flex;
  align-items: center;

  gap: 6px;

  margin:
    7px
    0
    0
    4px;

  color:
    #8d949e;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    8px;
}


.selected-dot {
  width: 5px;
  height: 5px;

  flex-shrink: 0;

  border-radius:
    50%;

  background:
    #3dbf78;

  box-shadow:
    0 0 0 3px
    rgba(
      61,
      191,
      120,
      0.09
    );
}


/* ============================================================
   DARK
============================================================ */

html[data-theme="dark"]
.hint {
  color:
    #9299a4;
}


html[data-theme="dark"]
.input-wrapper {
  background:
    #2d2f34;

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );
}


html[data-theme="dark"]
.input-wrapper:hover,
html[data-theme="dark"]
.input-wrapper:focus-within {
  background:
    #303238;
}


html[data-theme="dark"]
.input-wrapper.active {
  background:
    rgba(
      52,
      127,
      231,
      0.08
    );

  border-color:
    rgba(
      69,
      132,
      231,
      0.26
    );
}


html[data-theme="dark"]
.city-select {
  color:
    #eeeeef;
}


html[data-theme="dark"]
.city-select option {
  color:
    #eeeeef;

  background:
    #292b30;
}


html[data-theme="dark"]
.location-icon {
  color:
    #73a6ef;

  background:
    rgba(
      69,
      132,
      231,
      0.12
    );
}


html[data-theme="dark"]
.input-wrapper.active
.location-icon {
  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #347fe7,
      #5b68dc
    );
}


html[data-theme="dark"]
.selected-hint {
  color:
    #858c96;
}

</style>